import { AnyAction } from 'redux';
import { RESET_STATE, GET_GETTING_STARTED_STEPS, GET_TRIAL_DAYS_REMAINING } from '@app/store/constants';

const initialState = {
    steps: [],
    trialDaysRemaining: undefined
};

export function gettingStarted(state = initialState, action: AnyAction) {
    const {payload, type} = action;

    switch (type) {
        case RESET_STATE:
            return initialState;
        case GET_GETTING_STARTED_STEPS:
            return {
                ...state,
                steps: payload
            };
        case GET_TRIAL_DAYS_REMAINING:
            return {
                ...state,
                trialDaysRemaining: payload
            };
        default:
            return state;
    }
}
